var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.913 15.0881V13.4741C13.913 12.618 13.5729 11.7969 12.9675 11.1916C12.3622 10.5862 11.5411 10.2461 10.685 10.2461H4.228C3.37188 10.2461 2.55083 10.5862 1.94546 11.1916C1.34009 11.7969 1 12.618 1 13.4741V15.0881",
    stroke: "#38D982",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45456 7.0185C9.23734 7.0185 10.6826 5.57328 10.6826 3.7905C10.6826 2.00772 9.23734 0.5625 7.45456 0.5625C5.67179 0.5625 4.22656 2.00772 4.22656 3.7905C4.22656 5.57328 5.67179 7.0185 7.45456 7.0185Z",
    stroke: "#38D982",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7569 15.0896V13.4746C18.7564 12.7594 18.5183 12.0646 18.0801 11.4993C17.6419 10.9341 17.0284 10.5304 16.3359 10.3516",
    stroke: "#38D982",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1055 0.667969C13.8002 0.84549 14.416 1.24925 14.8558 1.81555C15.2955 2.38185 15.5343 3.07846 15.5343 3.79547C15.5343 4.51248 15.2955 5.20909 14.8558 5.77539C14.416 6.34169 13.8002 6.74545 13.1055 6.92297",
    stroke: "#38D982",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.3a3630041dcefbbbeb1b5c1da7807e96.svg";
export { ForwardRef as ReactComponent };